import { DictionariesDTO } from '@core/dto/dictionaries.dto';
import { deserialize, Model, Serializer } from '@junte/serialize-ts';

import { AssetClassValueObject } from './asset-class-value-object';
import { BaseModel } from './base-model';
import { ValueObject } from './value-object.model';

export class DictionariesSerializer implements Serializer<Dictionaries> {
  public deserialize(dto: DictionariesDTO): Dictionaries {
    return Dictionaries.create({
      assetClasses: [...dto.assetClass, ...dto.assetSubclass].map((item) => deserialize(item, AssetClassValueObject)),
      countries: dto.country.map((item) => deserialize(item, ValueObject)),
      esgCompliance: dto.esgCompliance.map((item) => deserialize(item, ValueObject)),
      industries: dto.industry.map((item) => deserialize(item, ValueObject)),
      investorClasses: dto.investorClass.map((item) => deserialize(item, ValueObject)),
      clientClass: dto.clientClass.map((item) => deserialize(item, ValueObject)),
      languages: dto.language.map((item) => deserialize(item, ValueObject)),
      ratings: dto.rating.map((item) => deserialize(item, ValueObject)),
      salutations: dto.salutation.map((item) => deserialize(item, ValueObject)),
      titles: dto.title.map((item) => deserialize(item, ValueObject)),
      occupation: dto.occupation.map((item) => deserialize(item, ValueObject)),
      businessType: dto.businessType.map((item) => deserialize(item, ValueObject)),
      mainSourceOfFunds: dto.mainSourceOfFunds.map((item) => deserialize(item, ValueObject)),
    });
  }

  // just to conform to the interface
  public serialize(): DictionariesDTO {
    return null;
  }
}

@Model(new DictionariesSerializer())
export class Dictionaries extends BaseModel {
  public assetClasses: AssetClassValueObject[];
  public countries: ValueObject[];
  public esgCompliance: ValueObject[];
  public industries: ValueObject[];
  public investorClasses: ValueObject[];
  public clientClass: ValueObject[];
  public languages: ValueObject[];
  public ratings: ValueObject[];
  public salutations: ValueObject[];
  public titles: ValueObject[];
  public occupation: ValueObject[];
  public businessType: ValueObject[];
  public mainSourceOfFunds: ValueObject[];

  public static create(data: Partial<Dictionaries>): Dictionaries {
    return Object.assign(new Dictionaries(), data);
  }
}
